import { styled } from '@mui/material/styles';
import { SelectMenu } from '../../../../components/atoms/SelectMenu';

export const StyledSelectMenu = styled(SelectMenu)`
  width: 25%;
  min-width: 25%;
`;